import tierQueries from '@apis/queries/tierQueries';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

function useTierBenefits() {
    const { data, isFetching } = useQuery(tierQueries.benefits());
    const period = useMemo(() => {
        if (data) {
            const { calculationPeriodType, calculationPeriodValue } = data;
            return `${calculationPeriodValue}${calculationPeriodType === 'DAILY' ? '일' : '개월'}`;
        }
        return undefined;
    }, [data]);
    return {
        ...data,
        period,
        isFetching,
    };
}

export default useTierBenefits;
